import { render, staticRenderFns } from "./role02.vue?vue&type=template&id=12f5a83a"
import script from "./role02.vue?vue&type=script&lang=js"
export * from "./role02.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports